import React from 'react';

function LogoutModal({ onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/50 p-4 animate-fade-in">
      <div className="w-full max-w-sm rounded-lg bg-white p-6 shadow-2xl animate-float-in dark:bg-slate-900">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-slate-100 dark:bg-slate-800">
            <svg className="h-7 w-7 text-slate-500 dark:text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
          </div>
          <h2 className="text-lg font-black text-slate-900 dark:text-slate-50">Logout?</h2>
          <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">Are you sure you want to logout from CloudRecords?</p>
        </div>
        <div className="flex gap-3">
          <button onClick={onCancel} className="min-h-11 flex-1 rounded-lg border border-slate-200 px-4 py-2.5 text-sm font-black text-slate-600 transition-all duration-150 hover:bg-slate-50 active:scale-[0.97] dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-800">Stay logged in</button>
          <button onClick={onConfirm} className="min-h-11 flex-1 rounded-lg bg-slate-900 px-4 py-2.5 text-sm font-black text-white transition-all duration-150 hover:bg-slate-800 active:scale-[0.97] dark:bg-white dark:text-slate-950">Yes, logout</button>
        </div>
      </div>
    </div>
  );
}

export default LogoutModal;
